import React from 'react';
import { TreeNode } from './types';
import { TreeItem, TreeItemProps } from './TreeItem';
import styled from 'styled-components';

/** Simple wrapper for the entire tree */
const TreeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
  user-select: none;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px;
  gap: 8px;
  width: 100%;
  min-width: 300px;
  min-height: 300px;
  height: 100%;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(8px);
  overflow-y: auto;
`;

/**
 * Props for the top-level <Tree> component.
 */
export type TreeProps = Pick<
  TreeItemProps,
  'state' | 'onNodeClick' | 'onToggleCollapse' | 'actions'
> & {
  /** Array of root nodes to render */
  nodes: TreeNode[];
};

/**
 * <Tree> handles:
 * - Top-level rendering of each root node
 * - Optionally controlling expanded IDs from above
 * - If not controlled, manages internal `expandedIds` state
 */
export const Tree: React.FC<TreeProps> = ({ nodes, ...restProps }) => {
  return (
    <TreeWrapper>
      {nodes.map((root) => (
        <TreeItem key={root.id} node={root} depth={0} {...restProps} />
      ))}
    </TreeWrapper>
  );
};
